module.exports = __webpack_public_path__ + "b0bc7b726e07dfcd2d183d3fb32915f2.svg";